// IBOs used by the opt-in mock API (REACT_APP_USE_MOCK_API=true) for offline
// dev and Storybook. Never served to a real user — see shared/api/client.js.
const ibos = [
  {
    id: "tom-jobes",
    iboNumber: "5327982",
    name: "Jones, Tom & Helen",
    searchLabel: "Tom Jobes",
    email: "tom.jobes@example.com",
    phone: "509.772.7735",
    pinLevel: "IBO",
    membership: "C",
    country: "US",
  },
  {
    id: "dana-reed",
    iboNumber: "6184203",
    name: "Reed, Dana",
    searchLabel: "Dana Reed",
    email: "dana.reed@example.com",
    phone: "208.555.0142",
    pinLevel: "PLA",
    membership: "P",
    country: "US",
  },
  {
    id: "ibo_42",
    iboNumber: "1004277",
    name: "Dana Rivera",
    pinLevel: "Platinum",
    country: "US",
    email: "dana@example.invalid",
    usersCount: 3,
  },
  {
    id: "ibo_77",
    iboNumber: "2299815",
    name: "Marc Lin",
    pinLevel: "Gold",
    country: "CA",
    email: "marc@example.invalid",
    usersCount: 1,
  },
  {
    id: "ibo_88",
    iboNumber: "3140002",
    name: "Priya Shah",
    pinLevel: "Silver",
    country: "US",
    email: "priya@example.invalid",
    usersCount: 2,
  },
];

export const iboUsers = {
  "tom-jobes": [
    {
      id: "tom-jones",
      name: "Tom Jones",
      role: "owner",
      email: "tom.jobes@example.com",
    },
    {
      id: "helen-jones",
      name: "Helen Jones",
      role: "spouse",
      email: "helen.jobes@example.com",
    },
  ],
  "dana-reed": [
    {
      id: "dana-reed",
      name: "Dana Reed",
      role: "owner",
      email: "dana.reed@example.com",
    },
  ],
  ibo_42: [
    {
      id: "usr_a1",
      name: "Dana Rivera",
      role: "owner",
      email: "dana@example.invalid",
    },
    {
      id: "usr_a2",
      name: "Sam Rivera",
      role: "spouse",
      email: "sam@example.invalid",
    },
    {
      id: "usr_a3",
      name: "Jo Rivera",
      role: "assistant",
      email: "jo@example.invalid",
    },
  ],
  ibo_77: [
    {
      id: "usr_b1",
      name: "Marc Lin",
      role: "owner",
      email: "marc@example.invalid",
    },
  ],
  ibo_88: [
    {
      id: "usr_c1",
      name: "Priya Shah",
      role: "owner",
      email: "priya@example.invalid",
    },
    {
      id: "usr_c2",
      name: "Ravi Shah",
      role: "spouse",
      email: "ravi@example.invalid",
    },
  ],
};

export default ibos;
